import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";

export function TabDadosSkeleton() {
  return (
    <div className="flex flex-col gap-4 mt-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <Skeleton className="h-6 sm:h-7 w-48" />
      </div>

      <Separator />

      <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {/* Nome skeleton */}
        <div className="rounded-md p-2">
          <Skeleton className="h-4 w-12 mb-1" />
          <Skeleton className="h-5 w-32" />
        </div>

        {/* Telefone skeleton */}
        <div className="rounded-md p-2">
          <Skeleton className="h-4 w-16 mb-1" />
          <Skeleton className="h-5 w-28" />
        </div>

        {/* Email skeleton */}
        <div className="rounded-md p-2">
          <Skeleton className="h-4 w-12 mb-1" />
          <Skeleton className="h-5 w-40" />
        </div>

        {/* CPF/CNPJ skeleton */}
        <div className="rounded-md p-2">
          <Skeleton className="h-4 w-20 mb-1" />
          <Skeleton className="h-5 w-36" />
        </div>
      </dl>

      <div className="flex justify-start">
        <Skeleton className="h-8 w-16" />
      </div>
    </div>
  );
}
